import {Injectable} from '@angular/core';
import {FixedAspectRatioImageDTO} from '../../api/api';
import {ModalService} from '../modal/modal.service';
import {ImageUploadModalComponent} from './image-upload-modal/image-upload-modal.component';
import {ImageUploadTransfer} from './model';

@Injectable({
  providedIn: 'root'
})
export class ImageUploadService {

  constructor(private modalService: ModalService) {

  }

  public imageUpload(title: string, image: FixedAspectRatioImageDTO = null): ImageUploadTransfer {
    const ret: ImageUploadTransfer = new ImageUploadTransfer();
    ret.image = image;
    this.modalService.showNavigationModal({
      entryComponent: {value: ImageUploadModalComponent, data: {transfer: ret}},
      title,
      icon: 'shareIcon',
      modalOptions: {size: 'lg'}
    }).then((e: unknown) => {
      ret.modalClosed.emit();
    }).catch((e: unknown) => {
      ret.modalClosed.emit();
    });

    return ret;
  }
}
